// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "selectedFlight_wrapper-1N4lr";
var _4 = "currencyWarning_wrapper-2JBSn";
var _5 = "priceWithNote-1uoGz";
var _6 = "note-c1BRd";
export { _1 as "__esModule", _2 as "mobile", _3 as "selectedFlight_wrapper", _4 as "currencyWarning_wrapper", _5 as "priceWithNote", _6 as "note" }
export default { "__esModule": _1, "mobile": _2, "selectedFlight_wrapper": _3, "currencyWarning_wrapper": _4, "priceWithNote": _5, "note": _6 }
